import { ValidationConfig } from '../../items/components/add-edit/add-edit.validation';
import { pluralize } from '../../../shared/utils/formatters.utils';

const HIGH_IMPACT_THRESHOLD = 100;

type ScopeType = 'item' | 'filters' | 'all';

export interface ScopeState {
   type: ScopeType;
   filters: {
      family: boolean;
      part: boolean;
   };
}

export interface ButtonConfig {
   showGoBack: boolean;
   primaryText: string;
   primaryType: 'emphasised' | 'primary' | 'secondary';
   primaryDisabled: boolean;
}

export const validateMaterialGradeId = (value: string, currentMaterialGradeId?: string): string | null => {
   if (!value) {
      return ValidationConfig.messages.common.required;
   }

   if (currentMaterialGradeId && value === currentMaterialGradeId) {
      return `Already set to ${currentMaterialGradeId}`;
   }

   if (!ValidationConfig.regex.id.test(value)) {
      return ValidationConfig.messages.common.idFormat;
   }

   return null;
};

export const getScopeDescription = (
   scope: ScopeState,
   itemNo: string,
   materialGrade: string,
   materialPart: string,
   familyName: string
): string => {
   switch (scope.type) {
      case 'item':
         return `Apply only to item "${itemNo}"`;
      case 'all':
         return `Apply to all items with "${materialGrade}"`;
      case 'filters':
         if (scope.filters.part && scope.filters.family) {
            return `Apply only within part "${materialPart}" and family "${familyName}"`;
         }
         if (scope.filters.part) {
            return `Apply only within part "${materialPart}"`;
         }
         return 'Select at least one filter';
      default:
         return 'Please select a scope option';
   }
};

export interface ButtonConfigParams {
   showHighImpactWarning: boolean;
   affectedCount: number | null;
   isHighImpact: boolean;
   isLoading: boolean;
   error: string | null;
   hasCheckedMapping: boolean;
   hasMappingData: boolean;
}

export const getButtonConfig = ({
   showHighImpactWarning,
   affectedCount,
   isHighImpact,
   isLoading,
   error,
   hasCheckedMapping,
   hasMappingData,
}: ButtonConfigParams): ButtonConfig => {
   if (showHighImpactWarning) {
      return {
         showGoBack: true,
         primaryText: affectedCount !== null ? `Confirm High Impact (${pluralize(affectedCount)})` : 'Confirm High Impact',
         primaryType: 'emphasised',
         primaryDisabled: affectedCount === null,
      };
   }

   return {
      showGoBack: false,
      primaryText: `Apply to Form${affectedCount ? ` (affects ${pluralize(affectedCount)})` : ''}`,
      primaryType: isHighImpact ? 'emphasised' : 'primary',
      primaryDisabled: isLoading || !!error || !hasCheckedMapping || !hasMappingData,
   };
};

export { HIGH_IMPACT_THRESHOLD };
